import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BaseServerData, IRestoreData, IStickyJump, jumpingWildConfig} from '../base/IData';
import { WinGameData, ReelGameData } from "./GameDataModels";
import { Helper } from '../../../core/utils/Helper';
import {PRGameMode} from "../PRGameMode";

export class GameData {

    public raw: BaseServerData;

    public Win: WinGameData;
    public Reel: ReelGameData;

    private _stickyJumps: IStickyJump[]= [];

    public get isRestoreState(): boolean {
        return this.raw.isRestoreState;
    }

    public get stickyJumps(): IStickyJump[] {
        return this._stickyJumps;
    }

    public get mode(): string {
        return this.raw.mode;
    }

    public get fsRestoreData(): IRestoreData {
        return Helper.fetchOrApply(this.raw.restoreData,{});
    }

    public get isNormalMode(): boolean {
        return this.raw.mode === GameMode.NORMAL;
    }

    public get isFreeSpin(): boolean {
        return ((this.raw.mode === PRGameMode.FREESPIN_LEVEL_ONE) || (this.raw.mode === PRGameMode.FREESPIN_LEVEL_TWO) || (this.raw.mode === PRGameMode.FREESPIN_LEVEL_THREE));
    }

    public get nextIsRespin():boolean{
        return this.raw.nextMode === "RESPIN";
    }

    public get nextMode(): string {
        return this.raw.nextMode;
    }

    public get lastFSRound(): boolean {
        return ((this.raw.mode === PRGameMode.FREESPIN_LEVEL_ONE) || (this.raw.mode == PRGameMode.FREESPIN_LEVEL_TWO) || (this.raw.mode === PRGameMode.FREESPIN_LEVEL_THREE)) && this.raw.nextMode === GameMode.NORMAL;
    }

    public get isNextFS(): boolean {
        return this.raw.mode !== PRGameMode.FREESPIN_LEVEL_ONE && this.raw.nextMode === PRGameMode.FREESPIN_LEVEL_ONE;
    }

    public get gameModeChanges(): boolean {
        return this.raw.mode !== this.raw.nextMode;
    }

    constructor(){
        this.Reel = new ReelGameData();
        this.Win = new WinGameData();
    }

    public setData(data:BaseServerData):void{
        //console.log("GAME DATA:", data);
        this.raw = data;
        this.Reel.apply(data)
        this.Win.apply(data)
        this._stickyJumps = this.decryptStickyJumpPosition(data.jumpingWildList)
    }

    private decryptStickyJumpPosition(jumpingWildList:jumpingWildConfig[]):IStickyJump[]{
        if(jumpingWildList.length === 0) return [];

        const res:IStickyJump[] = [];

        for (let i: number = 0; i < jumpingWildList.length; i++) {
            const currWildData: jumpingWildConfig = jumpingWildList[i],
                currFromPos: PIXI.Point = new PIXI.Point(currWildData.previousCoord.x, currWildData.previousCoord.y),
                currToPos: PIXI.Point = new PIXI.Point(currWildData.newCoord.x, currWildData.newCoord.y),
                currMultFrom: number = currWildData.previousMulti,
                currMultTo: number = currWildData.newMultiplier,
                currIsNewJW: boolean = currWildData.isNewJW,
                jumpData: IStickyJump = {
                    from: currFromPos,
                    to: currToPos,
                    mult: currMultFrom,
                    multNew: currMultTo,
                    isNewJW: currIsNewJW
                };

            res.push(jumpData);
        }
        return res;
    }
}